if (!customElements.get("m-announcement-bar")) {
  class MAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initCountdowns();

      const enableSlider = this.dataset.enableSlider === "true";
      if (!enableSlider) return;
      this.initSlider();
    }

    initCountdowns() {
      this.querySelectorAll("[data-countdown-announcement]").forEach((countdownContent) => {
        if (countdownContent.dataset.countdownMode === "rolling_24") return;

        const timer = countdownContent.querySelector(".m-announcement-bar__countdown");
        const maxTimeout = 2147483647;
        const endTime = this.parseCountdownEnd(countdownContent);

        if (countdownContent.dataset.countdownEnded === "true") {
          this.showCountdownFallback(countdownContent);
          return;
        }

        if (Number.isFinite(endTime) && endTime <= Date.now()) {
          this.showCountdownFallback(countdownContent);
          return;
        }

        if (Number.isFinite(endTime)) {
          const scheduleFallback = () => {
            const delay = endTime - Date.now();
            if (delay <= 0) {
              this.showCountdownFallback(countdownContent);
              return;
            }

            window.setTimeout(scheduleFallback, Math.min(delay, maxTimeout));
          };

          scheduleFallback();
        }

        if (!timer) return;

        timer.addEventListener("countdown:ended", (event) => {
          const currentContent = event.currentTarget.closest("[data-countdown-announcement]");
          if (currentContent) {
            this.showCountdownFallback(currentContent);
          }
        });

        if (timer.dataset.countdownEnded === "true") {
          this.showCountdownFallback(countdownContent);
        }
      });
    }

    showCountdownFallback(countdownContent) {
      const fallback = countdownContent.querySelector(".m-announcement-bar__countdown-fallback");
      if (!fallback) return;

      const message = countdownContent.querySelector(".m-announcement-bar__message");
      if (message) {
        message.hidden = true;
        message.classList.add("m:hidden");
      }

      const timer = countdownContent.querySelector(".m-announcement-bar__countdown");
      if (timer) {
        timer.hidden = true;
        timer.classList.add("m:hidden");
      }

      countdownContent.dataset.countdownEnded = "true";
      countdownContent.classList.add("is-countdown-ended");
      fallback.hidden = false;
      fallback.classList.remove("m:hidden");
    }

    parseCountdownEnd(countdownContent) {
      const countdownEnd = countdownContent.dataset.countdownEnd || "";
      const parsedEnd = Date.parse(countdownEnd);
      if (!Number.isNaN(parsedEnd)) return parsedEnd;

      const parseDateParts = (value) => {
        const trimmed = value.trim();
        const isoMatch = trimmed.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})$/);
        const usMatch = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);

        if (isoMatch) return [Number(isoMatch[1]), Number(isoMatch[2]), Number(isoMatch[3])];
        if (usMatch) return [Number(usMatch[3]), Number(usMatch[1]), Number(usMatch[2])];

        return null;
      };
      const date = countdownContent.dataset.countdownDate || "";
      const time = countdownContent.dataset.countdownTime || "";
      const timezone = countdownContent.dataset.countdownTimezone || "";
      const dateParts = parseDateParts(date);
      const timeMatch = time.trim().match(/^(\d{1,2})(?::(\d{2}))?(?::(\d{2}))?\s*(am|pm)?$/i);
      const timezoneMatch = timezone.trim().match(/^([+-])(\d{2}):?(\d{2})$/);

      if (!dateParts || !timeMatch || !timezoneMatch) return NaN;

      const [year, month, day] = dateParts;
      let hour = Number(timeMatch[1]);
      const minute = Number(timeMatch[2] || 0);
      const second = Number(timeMatch[3] || 0);
      const meridiem = timeMatch[4] ? timeMatch[4].toLowerCase() : "";

      if (meridiem === "pm" && hour < 12) hour += 12;
      if (meridiem === "am" && hour === 12) hour = 0;
      if (hour > 23 || minute > 59 || second > 59) return NaN;

      const offsetSign = timezoneMatch[1] === "+" ? 1 : -1;
      const offsetMinutes = offsetSign * (Number(timezoneMatch[2]) * 60 + Number(timezoneMatch[3]));
      const utcTime = Date.UTC(year, month - 1, day, hour, minute, second);

      return utcTime - offsetMinutes * 60 * 1000;
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const slideContainer = this.querySelector(".swiper-container");
      if (slideContainer) {
        this.slider = new MinimogLibs.Swiper(slideContainer, {
          slidesPerView: 1,
          slidesPerGroup: 1,
          autoplay: autoplay
            ? {
                delay: parseInt(autoplaySpeed) * 1000,
              }
            : false,
          loop: true,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
        });
      }
    }
  }

  customElements.define("m-announcement-bar", MAnnouncementBar);
}
